import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { FreelancerReputation } from '@freelancer/datastore/collections';
import { IconSize } from '@freelancer/ui/icon';
import { Margin } from '@freelancer/ui/margin';

@Component({
  selector: 'app-user-profile-summary-rating',
  template: `
    <fl-bit *ngIf="!isDeloitteDcUser" class="RatingContainer">
      <fl-tooltip
        i18n-message="Tooltip message for freelancer rating"
        message="Average rating for all completed projects."
      >
        <fl-rating
          [flShowMobile]="true"
          [control]="ratingControl"
          [compact]="true"
          [readOnly]="true"
          [size]="IconSize.SMALL"
          [flMarginRight]="Margin.XXSMALL"
          [reviewCount]="reputation?.entireHistory.reviews || 0"
        ></fl-rating>
        <fl-rating
          [flHideMobile]="true"
          [control]="ratingControl"
          [readOnly]="true"
          [size]="IconSize.SMALL"
          [reviewCount]="reputation?.entireHistory.reviews || 0"
          [flMarginRight]="Margin.LARGE"
        ></fl-rating>
      </fl-tooltip>
      <fl-tooltip
        i18n-message="Tooltip message for freelancer earnings"
        message="Amount earned doing projects in this skill or category. Increases as projects are successfully completed and paid through the site."
      >
        <fl-earnings
          [flShowMobile]="true"
          [earnings]="reputation?.earningsScore || 0"
          [compact]="true"
        ></fl-earnings>
        <fl-earnings
          [flHideMobile]="true"
          [earnings]="reputation?.earningsScore || 0"
        ></fl-earnings>
      </fl-tooltip>
    </fl-bit>
    <fl-worked-time
      *ngIf="isDeloitteDcUser"
      i18n-tooltipMessage="Deloitte Worked time tooltip message"
      tooltipMessage="Hours of experience working on MyGigs projects"
      [flMarginRight]="Margin.XSMALL"
      [time]="reputation?.earningsScore || 0"
    >
    </fl-worked-time>
  `,
  styleUrls: ['./user-profile-summary-rating.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserProfileSummaryRatingComponent {
  Margin = Margin;
  IconSize = IconSize;

  private _reputation: FreelancerReputation;
  ratingControl = new FormControl(0);

  @Input() set reputation(reputation: FreelancerReputation) {
    if (reputation) {
      this._reputation = reputation;
      this.ratingControl.setValue(this._reputation.entireHistory.overall);
    }
  }
  @Input() isDeloitteDcUser?: boolean;

  get reputation() {
    return this._reputation;
  }
}
